import 'tippy.js/dist/tippy.css'

import { DateFormat, t } from '@lingui/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans, withI18n } from '@lingui/react'
import { faCheck, faLock } from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import Tippy from '@tippy.js/react'
import cx from 'classnames'

import { LessonType } from 'common-proptypes'
import { prefixUrl } from 'utils'

import styles from './CourseLesson.module.scss'

/* eslint-disable react/no-danger */

export default withI18n()(class CourseLesson extends React.PureComponent {
  static propTypes = {
    // data
    userCurriculumAssignmentId: PropTypes.number.isRequired,
    curriculumSectionId: PropTypes.number.isRequired,
    lesson: LessonType.isRequired,
    lockReason: PropTypes.string,
    // HOC-mapped
    i18n: PropTypes.object,
    // render props
    renderLessonStatusText: PropTypes.func,
    renderLessonStatusIcon: PropTypes.func,
    getLessonStatus: PropTypes.func,
  }

  static defaultProps = {
    getLessonStatus: (props) => {
      const {
        lesson: {
          complete,
        },
        lockReason,
      } = props
      if(lockReason) return 'locked'
      if(complete) return 'complete'
      return 'new'
    },

    renderLessonStatusIcon: (props) => {
      const {
        getLessonStatus,
        lockReason,
        i18n,
      } = props
      const lessonStatus = getLessonStatus(props)
      switch(lessonStatus) {
        case 'locked':
          return <FontAwesomeIcon icon={faLock} aria-label={i18n._(t`locked`)} title={i18n._(lockReason)} />
        case 'complete': {
          const dateCompleted = new Date()
          return (
            <Trans
              render={({ translation }) => (
                <FontAwesomeIcon
                  icon={faCheck}
                  aria-label={i18n._(t`completed`)}
                  title={translation}
                />
              )}
            >
              You completed this lesson on <DateFormat value={dateCompleted} format={{ month: 'short', day: 'numeric' }} />
            </Trans>
          )
        }
        default:
          return null
      }
    },

    renderLessonStatusText: (props) => {
      const {
        getLessonStatus,
        lockReason,
      } = props
      const lessonStatus = getLessonStatus(props)
      switch(lessonStatus) {
        case 'locked':
          return <small><Trans id={lockReason} /></small>
        case 'complete':
          return (
            <small>
              <span role="img" aria-label="trophy">🏆</span>
              &nbsp;
              <Trans>
                You completed this lesson on <DateFormat value={new Date()} format={{ month: 'short', day: 'numeric' }} />
              </Trans>
            </small>
          )
        default:
          return null
      }
    },
  }

  componentWillUnmount() {
    if(this.tipRef) {
      this.tipRef.destroy()
    }
  }

  tipRef = undefined

  render() {
    const {
      userCurriculumAssignmentId,
      curriculumSectionId,
      lesson,
      lockReason,
      renderLessonStatusIcon,
      renderLessonStatusText,
      getLessonStatus,
    } = this.props
    const {
      name,
      objectName,
      objectId,
      objectHash,
      curriculumSectionItemId,
      // description,
    } = lesson
    const curriculumPath = [userCurriculumAssignmentId, curriculumSectionId, curriculumSectionItemId]
    const curriculumPathStr = curriculumPath.join('%2c')
    const launchHref = objectName === 'Lesson'
      ? prefixUrl(`/Module/security.ashx?curriculum=${curriculumPathStr}&id=${objectId}&hash=${objectHash}`)
      : prefixUrl(`/TestingEngine/Testing/BeginTest.aspx?curriculum=${curriculumPathStr}&TestID=${objectId}`)

    const lessonStatus = getLessonStatus(this.props)
    const $lessonStatusIcon = renderLessonStatusIcon(this.props)
    const $lessonStatusText = renderLessonStatusText(this.props)

    const locked = lessonStatus === 'locked'

    /* eslint-disable jsx-a11y/anchor-is-valid */
    return (
      <article
        className={cx('course-lesson', styles.root, {
          [styles[lessonStatus]]: true,
        })}
      >
        <div className={styles.inner}>
          <div className={styles.header}>
            <span className={styles.statusIcon}>
              {$lessonStatusIcon}
            </span>
            <div className={cx(styles.title)}>{name}</div>
            {locked ? (
              <span role="button" aria-disabled className={cx('button', styles.button)}>
                <span className="text">
                  <Trans>Locked</Trans>
                </span>
              </span>
            ) : (
              <a
                className={cx('button', styles.button)}
                href={ "javascript:(function() { window.lessonWindowHandle = window.open('"+launchHref+"', 'lessonWindow'); return; })()" }
              >
                <span className="text">
                  <Trans>Launch</Trans>
                </span>
              </a>
            )}
          </div>
          <div className={styles.body}>
            {/* lesson.description && (
              <div className={styles.description} dangerouslySetInnerHTML={{ __html: lesson.description }} />
            ) */}
            {$lessonStatusText && (
              <div className={styles.statusText}>{$lessonStatusText}</div>
            )}
          </div>
        </div>
        {locked && (
          <Tippy
            content={lockReason}
            delay={[200, null]}
            arrow
            key={objectHash}
          >
            <div key={objectHash} className={styles.disabledOverlay} />
          </Tippy>
        )}
      </article>
    )
  }
})
